import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as contexts from '../../contexts'
import type { Feature } from '../feature'

/**
 * When context for user assignment changes, request users for that context
 */
export const requestUsersForAssignment = store.effects.create(
  (feature: Feature, _contexts: contexts.Feature) =>
    rxjs
      .combineLatest({
        context: _contexts.selectors.contextForAgentAssignment.asObservable,
        isEditing: feature.selectors.isEditing.asObservable,
      })
      .pipe(
        rxjs.debounceTime(500),
        rxjs.filter(({ isEditing }) => isEditing),
        rxjs.map(({ context }) =>
          feature.actions.listUsers
            .from('requestUsersForAgentAssignment (effect)')
            .create({ filters: { context } }),
        ),
      ),
)
